<template>
  <v-container class="justify-center">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" md="4"></v-col>
        <v-col cols="12" md="4">
          <v-img
            class="mx-auto"
            max-width="180px"
            :src="require('@/assets/logo_simple.jpg')"
          ></v-img>
          <h3 class="mt-3 text-center display-1 font-weight-bold">
            Make It Simple
          </h3>
          <v-card outlined class="pa-3 mt-3">
            <v-text-field
              class="mt-5"
              dense
              outlined
              v-model="form.username"
              :rules="nameRules"
              label="ชื่อผู้ใช้"
              required
            ></v-text-field>
            <v-text-field
              dense
              outlined
              v-model="form.password"
              :rules="emailRules"
              label="รหัสผ่าน"
              type="password"
              required
            ></v-text-field>
            <v-layout justify-space-between class="mt-2">
              <v-btn
                :disabled="!valid"
                :loading="loading"
                color="primary"
                class="mr-4"
                @click="validate"
                >เข้าสู่ระบบ</v-btn
              >
              <a href="https://selfservice.lpn.co.th:8888">ลืมรหัสผ่าน?</a>
            </v-layout>
          </v-card>
          <!-- <v-btn
            :disabled="!valid"
            color="primary"
            rounded
            class="mr-4"
            block
            @click="validate"
          >
            เข้าสู่ระบบ
          </v-btn>
          <v-btn
            color="primary"
            outlined
            rounded
            class="mr-4 mt-4"
            block
            @click="reset"
          >
            ลืมรหัสผ่าน
          </v-btn>-->
        </v-col>
        <v-col cols="12" md="4"></v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    name: "",
    nameRules: [(v) => !!v || "ระบุชื่อผู้ใช้"],
    email: "",
    emailRules: [(v) => !!v || "ระบุรหัสผ่าน"],
    form: {},
    loading: false,
  }),
  created() {},
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        //** เมื่อกรอกข้อมูลครบ */
        this.doAuthen();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async doAuthen() {
      this.loading = true;
      let formData = {
        username: this.form.username,
        password: this.form.password,
        system: "make-it-simple",
      };
      let response = await this.PostHttpWithOutSystem(
        "Authentication",
        formData
      );
      let text = "";
      let makeItSimpleObj = {};
      if (response.status === "success") {
        let { res } = await this.GetHttp("MISPV2/GetProfileEmp");
        let listsProfileEmp = [];
        let obj = response.res.data;
        if (res.data.status) {
          listsProfileEmp = res.data.lists_profile_emp || [];
        }

        if (listsProfileEmp.length > 0) {
          makeItSimpleObj = {
            loginCode: formData.username.toLowerCase(),
            ROLE_DESC: "",
            roleId: 2,
            EORG_03: listsProfileEmp.find(
              (i) => i.USERNAME == formData.username.toLowerCase()
            )?.EORG_03,
            EORG_04: listsProfileEmp.find(
              (i) => i.USERNAME == formData.username.toLowerCase()
            )?.EORG_04,
            jwt: obj.jwt,
            refreshToken: obj.refreshToken,
          };
        } else {
          makeItSimpleObj = {
            loginCode: formData.username.toLowerCase(),
            ROLE_DESC: "",
            roleId: 2,
            EORG_03: "",
            EORG_04: "",
            jwt: obj.jwt,
            refreshToken: obj.refreshToken,
          };
        }

        //console.log(makeItSimpleObj)

        // text = 'สำเร็จ'
        // let res = await this.PostHttp("MISPV2/chkRole",{loginCode:this.form.username.toLowerCase()})
        // console.log(res.res.data.res[0])
        // let role = res.res.data.res[0]
        // this.loading = false;
        //   let obj = response.res.data;
        //   let makeItSimpleObj = {
        //     loginCode: this.form.username.toLowerCase(),
        //     ROLE_DESC: role?.ROLE_DESC,
        //     roleId: role?.ROLE_ID,
        //     EORG_03: role?.EORG_03,
        //     EORG_04: role?.EORG_04,
        //     jwt: obj.jwt,
        //     refreshToken: obj.refreshToken
        //     // org: this.getUserAllLookUp[this.form.username.toLowerCase()] && this.getUserAllLookUp[this.form.username.toLowerCase()].EORG_04
        //   };
        //console.log(makeItSimpleObj);

        this.refreshToken(makeItSimpleObj);
      }
      // else {
      //   text = `เข้าสู้ระบบไม่สำเร็จ กรุณาตรวจข้อมูลของท่านอีกครั้ง`;
      //   this.$store.dispatch("getSnackbar", { text, status: response.status });
      //   this.loading = false;
      // }
    },
  },
};
</script>